import { Action } from '@ngrx/store';
import { Befreiung } from '../befreiung/shared/entities/befreiung';
import { BefreiungErgebnis } from '../befreiung/shared/entities/befreiungErgebnis';
import { LoginData } from '../session/entities/LoginModel';
import { PasswordChangedModel } from '../account/changepassword/entities/passwordChangedModel';

export const BEFREIUNG_GEFUNDEN = 'BEFREIUNG_GEFUNDEN';
export const PASSWORT_GEAENDERT = 'PASSWORT_GEAENDERT';
export const IK_REGISTRIERT = 'IK_REGISTRIERT';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const IDLE = 'IDLE';
export const ERROR = 'ERROR';

export interface ActionWithPayload<T> extends Action {
  payload: T;
}

export class BefreiungGefundenAction implements ActionWithPayload<BefreiungErgebnis> {
  readonly type = BEFREIUNG_GEFUNDEN;
  
  constructor(public payload: BefreiungErgebnis) {}
}

export class PasswortGeaendertAction implements ActionWithPayload<PasswordChangedModel> {
  readonly type = PASSWORT_GEAENDERT;
  constructor(public payload: PasswordChangedModel) {}
}

export class IkRegistriertAction implements ActionWithPayload<void> {
  readonly type = IK_REGISTRIERT;
  payload=null;
}

export class LoginAction implements ActionWithPayload<LoginData> {
  readonly type = LOGIN;

  constructor(public payload: LoginData) {}
}

export class LogoutAction implements ActionWithPayload<void> {
  readonly type = LOGOUT;
  payload=null;
}

export class IdleAction implements ActionWithPayload<number> {
  readonly type = IDLE;

  constructor(public payload: number) {}
}
export class ErrorAction implements ActionWithPayload<any> {
  readonly type = ERROR;

  constructor(public payload: any) {}
}

export type All
= BefreiungGefundenAction
| PasswortGeaendertAction
| IkRegistriertAction
| LoginAction
| LogoutAction
| IdleAction
| ErrorAction;


// WEBPACK FOOTER //
// ./src/app/appState/app.actions.ts